import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { ArticlesPrintPTagAndQuantityAcknowledge } from "@coworker/apprestructured/src/task-management/components/ArticlesPrintPTagAndQuntityAcknowledge/ArticlesPrintPTagAndQuantityAcknowledge";
import { ItemNoAndTypeWithOrderedDetailsAcknowledge } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";

function ArticlesPrintPTagAndQuantityAcknowledgeDemo() {
  const [title, setTitle] = useState("getNewArticlesString");
  const [subTitle, setSubTitle] = useState("writeOffArticleWithSGFString");
  const [disabled, setDisabled] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pieces, setPieces] = useState(true);
  const [pTags, setPTags] = useState(true);
  const [confirmCount, setConfirmCount] = useState(0);
  const [itemsForAcknowledge, setItemsForAcknowledge] = useState<
    ItemNoAndTypeWithOrderedDetailsAcknowledge[]
  >([
    {
      no: "30373588",
      type: "ART",
      pieces: 5,
      pieces_ordered: 3,
      ptags_ordered: 2,
      pieces_acknowledge: false,
      ptags_acknowledge: false,
    },
    {
      no: "40586508",
      type: "ART",
      pieces: 7,
      pieces_ordered: 4,
      ptags_ordered: 1,
      pieces_acknowledge: false,
      ptags_acknowledge: false,
    },
  ]);

  return (
    <Demo>
      <Name>ArticlesPrintPTagAndQuantityAcknowledge</Name>
      <Highlight>
        <FixaListView
          id="articles-print-ptag-quantity-acknowledge-demo"
          size="small"
        >
          <ArticlesPrintPTagAndQuantityAcknowledge
            title={title}
            subTitle={subTitle}
            pieces={pieces}
            pTags={pTags}
            disabled={disabled}
            isError={isError}
            itemNosAndTypeWithOrderedDetailsAcknowledge={itemsForAcknowledge}
            onAcknowledgeChange={(itemNo, field, approved) => {
              setItemsForAcknowledge((prev) =>
                prev.map((item) =>
                  item.no === itemNo ? { ...item, [field]: approved } : item
                )
              );
            }}
            handleConfirm={() => setConfirmCount((prev) => prev + 1)}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          id="articlesprintptagandquantityacknowledgedemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          label="title"
        />
        <FixaInputField
          id="articlesprintptagandquantityacknowledgedemo-subtitle"
          value={subTitle}
          onChange={(e) => setSubTitle(e.target.value)}
          type="text"
          label="subTitle"
        />
        <FixaInputField
          id="articlesprintptagandquantityacknowledgedemo-confirmcount"
          value={String(confirmCount)}
          onChange={() => {}}
          type="text"
          label="confirmCount (read only)"
          disabled
        />
        <FixaCheckbox
          label="disabled"
          value="articlesprintptagandquantityacknowledgedemo-disabled"
          id="articlesprintptagandquantityacknowledgedemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
        <FixaCheckbox
          label="isError"
          value="articlesprintptagandquantityacknowledgedemo-iserror"
          id="articlesprintptagandquantityacknowledgedemo-iserror"
          checked={isError}
          onChange={() => setIsError((prev) => !prev)}
        />
        <FixaCheckbox
          label="pieces"
          value="articlesprintptagandquantityacknowledgedemo-pieces"
          id="articlesprintptagandquantityacknowledgedemo-pieces"
          checked={pieces}
          onChange={() => setPieces((prev) => !prev)}
        />
        <FixaCheckbox
          label="pTags"
          value="articlesprintptagandquantityacknowledgedemo-ptags"
          id="articlesprintptagandquantityacknowledgedemo-ptags"
          checked={pTags}
          onChange={() => setPTags((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(ArticlesPrintPTagAndQuantityAcknowledgeDemo);
